import { forwardRef } from "react";
import { clsx } from "clsx";

import "./Card.css";

import type { ReactNode, CSSProperties } from "react";

export interface CardProps {
  appearance?: "light" | "dark";
  children: ReactNode;
  style?: CSSProperties;
}

/** @deprecated use Block */
export const Card = forwardRef<HTMLDivElement, CardProps>(function CardImpl(
  { appearance, children, style },
  ref,
) {
  const className = clsx("Card", {
    [`Card--${appearance}`]: appearance,
  });

  return (
    <div ref={ref} className={className} style={style}>
      {children}
    </div>
  );
});
